import type { CustomIconProps } from '../types';

const Check = ({ width, height, color }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '8'}
        viewBox="0 0 13 9"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6367 1.44843L4.34501 8.80908L0.636719 5.15142L1.32239 4.54494L4.3802 7.561L11.9862 0.809082L12.6367 1.44843Z"
            fill={color ?? '#414042'}
        />
    </svg>
);

export default Check;
